import React from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import { OperatorSidebar } from './OperatorSidebar';

/**
 * Operator Layout - Operator sidebar with operator routes
 * Used for: /operator/*
 */
export const OperatorLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-slate-50" data-testid="operator-layout">
      <OperatorSidebar />
      <main className="flex-1 p-8">
        <div className="max-w-7xl mx-auto">
          {children || <Outlet />}
        </div>
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default OperatorLayout;
